/* eslint-disable react/no-unknown-property */
import { Fragment, useCallback } from 'react';
import { removeHtmlTags, getDataUTC, removeDoubleQuotesFromBlockquotes } from '@portal-internet/core';
import Enllac from 'components/3catinfo/Enllac';
import { getImatge } from 'components/3catinfo/Imatge';
import __isEmpty from 'lodash/isEmpty';

export default function ItemNoticia(props) {
    const {
        cos,
        data_publicacio,
        data_modificacio,
        redactor,
        titol,
        avantitol,
        mediadestacats,
        imatges,
        videos,
        audios,
        isWebviewActive,
        autors,
        noticies
    } = props;

    const entradeta = removeHtmlTags(props.entradeta);

    const dateFormat = (date) => {
        if (__isEmpty(date)) return null;
        const dateSplit = date.split(' ');
        const timeSplit = dateSplit[1]?.split(':');
        const dateFormatted = dateSplit[0] + ' - ' + timeSplit[0] + '.' + timeSplit[1];
        return dateFormatted;
    };

    const getSignature = () => {
        return (
            <>
                {autors?.map((item, index) => {
                    const route = { slug: item.nom, id: item.id, tipologia: 'NOT_AUTOR' };
                    const total = autors.length - 1;
                    return (
                        <Fragment key={`div-${item.id}-${index}`}>
                            <Enllac route={route} dataTestId='item-autor-enllac'>
                                {item.nom}
                            </Enllac>

                            {index < total - 1 && <>,&nbsp;</>}
                            {index === total - 1 && <>&nbsp;i&nbsp;</>}
                        </Fragment>
                    );
                })}
            </>
        );
    };
    const getDataPublicacio = () => {
        return (
            <>
                <div>
                    {!autors && redactor && <p className=''>{redactor}</p>}
                    <p>
                        <time dateTime={getDataUTC(data_publicacio)} itemProp='datePublished'>
                            {dateFormat(data_publicacio)}{' '}
                        </time>
                        {data_modificacio && (
                            <time dateTime={getDataUTC(data_modificacio)} itemProp='dateModified'>
                                <span>Actualitzat {dateFormat(data_modificacio)}</span>
                            </time>
                        )}
                    </p>
                </div>
            </>
        );
    };

    const getMediaDestacat = () => {
        const placeholder_url = 'https://statics.3cat.cat/img/recurs/img-loading.svg';
        if (mediadestacats?.idName === 'VIDEO' && !__isEmpty(videos) && !isWebviewActive) {
            const video_url = 'https://embed.3cat.cat/video/amp/embed/' + videos[0].id;

            return (
                <div className='' data-testid='noticia-media-video'>
                    <div className=''>
                        {/* <Player id={videos[0].id} /> */}
                        <amp-video-iframe layout='responsive' width='640' height='360' src={video_url} noloading=''>
                            <amp-img placeholder src={placeholder_url} width='1' height='1'></amp-img>
                        </amp-video-iframe>
                    </div>
                </div>
            );
        } else if (mediadestacats?.idName === 'AUDIO' && !__isEmpty(audios) && !isWebviewActive) {
            const audio_url = 'https://embed.3cat.cat/audio/amp/embed/' + audios[0].id;
            return (
                <div className='' data-testid='noticia-media-audio'>
                    <div className=''>
                        {/* <Player id={audios[0].id} tipus='audio' estils='noticia' /> */}
                        <amp-video-iframe layout='responsive' width='640' height='360' src={audio_url} noloading=''>
                            <amp-img placeholder src={placeholder_url} width='1' height='1'></amp-img>
                        </amp-video-iframe>
                    </div>
                </div>
            );
        } else if (!__isEmpty(imatges)) {
            const imatgeDestacat = getImatge(imatges, 'web_destacat', null, '640x433').src;
            return (
                <div data-testid='noticia-media-imatge' className='amp-mpImatge'>
                    <amp-img src={imatgeDestacat} width='640' height='433' layout='responsive' alt='' />
                </div>
            );
        }
    };

    const getDataNoticies = (items) => {
        return (
            <div>
                <h3 className='amp-titolSecundari'>Avui és notícia</h3>

                <ul className='amp-relacionades'>
                    {items?.map((item, index) => {
                        const route = { slug: item.permatitle, id: item.id, tipologia: item.tipologia };
                        return (
                            <li key={`llistat-notis-${index}`} className='amp-relacionada'>
                                <h3>
                                    <Enllac marcatgeAudienciesClick='Tira:1:Blocs temàtics. Avui és notícia' route={route}>
                                        {item.titol}
                                    </Enllac>
                                </h3>
                                <div className='amp-imgWrapper'>
                                    <amp-img
                                        src={getImatge(item.imatges, 'web_destacat', null, '320x240').src}
                                        width='320'
                                        height='240'
                                        layout='fill'
                                    />
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    };

    const getParseCos = useCallback((html) => {
        const removeObject = (html) => html.replace(/<object\b[^>]*>[\s\S]*?<\/object>/gi, '');
        const pipe =
            (...fns) =>
            (input) =>
                fns.reduce((acc, fn) => fn(acc), input);

        const sanitizeAmp = pipe(removeObject, removeDoubleQuotesFromBlockquotes);
        return sanitizeAmp(html);
    }, []);

    return (
        <>
            <style jsx global>{`
                .amp-itemNoticia {
                    position: relative;
                    margin: 0 auto 72px;
                    max-width: 1104px;
                    padding: 0 16px;
                }
                .amp-mpImatge {
                    font-size: 0;
                }
                .amp-titol {
                    font-size: 29px;
                    font-weight: 900;
                }
                .amp-entradeta {
                    font-weight: 500;
                    font-size: 20px;
                    margin-bottom: 32px;
                }
                .amp-info {
                    background: #f0f3f4;
                    border-radius: 8px;
                    padding: 24px 16px 16px;
                    margin: 0 0 48px 0;
                }
                .amp-data {
                    color: #455054;
                    font-size: 12px;
                    line-height: 18px;
                }
                .amp-data p {
                    margin: 0;
                }
                .amp-data p span {
                    display: block;
                    margin-top: 4px;
                }
                .amp-autor {
                    font-size: 16px;
                    color: #111617;
                    font-weight: 700;
                    margin-bottom: 16px;
                    padding-bottom: 16px;
                    border-bottom: 1px solid #dce3e5;
                }
                .amp-autor a {
                    color: #111617;
                    text-decoration: underline;
                }
                .amp-cos {
                    font-size: 18px;
                    line-height: 26px;
                    font-weight: 400;
                    color: #111617;
                }
                .amp-cos a {
                    color: #c74e05;
                    text-decoration: underline;
                    font-weight: 700;
                }
                .amp-cos blockquote {
                    padding-left: 64px;
                    padding-right: 64px;
                    margin: 40px 16px;
                    max-width: 100%;
                    color: #455054;
                    font-size: 20px;
                    line-height: 29px;
                    font-style: italic;
                    font-weight: 400;
                    background: url('/_resources/imatges/noticies_quote.svg?v=JIT_ENV_RESOURCES_VERSION') 0 -10px no-repeat;
                    background-size: 48px;
                    position: relative;
                }
                .amp-cos blockquote:after {
                    content: '';
                    display: block;
                    position: absolute;
                    right: 0;
                    bottom: -14px;
                    background: url(/_resources/imatges/noticies_quote.svg?v=JIT_ENV_RESOURCES_VERSION) 0 0 no-repeat;
                    background-size: 48px;
                    width: 48px;
                    height: 48px;
                    transform: rotate(180deg);
                }
                .amp-cos h2 {
                    font-size: 23px;
                    line-height: 32px;
                    font-weight: 500;
                    margin: 24px 0;
                }
                .amp-titolSecundari {
                    font-size: 26px;
                    font-weight: 700;
                    line-height: 35px;
                    margin-bottom: 24px;
                    margin-top: 32px;
                }
                .amp-cos figure figcaption {
                    font-size: 12px;
                    color: #455054;
                    line-height: 18px;
                    margin-top: 16px;
                }
                .amp-cos figure.imatge {
                    margin: 48px 0;
                }
                .amp-cos ul {
                    list-style-type: disc;
                    padding-left: 32px;
                }
                .amp-cos ul li {
                    margin-bottom: 16px;
                }
                .amp-cos ul li::marker {
                    color: #ff8135;
                }
                .amp-relacionades {
                    padding: 0;
                }
                .amp-relacionada {
                    display: flex;
                    flex-direction: row-reverse;
                    align-items: flex-start;
                    gap: 16px;
                    margin-bottom: 32px;
                }
                .amp-relacionada h3 {
                    margin: 0;
                }
                .amp-relacionada a {
                    color: #111617;
                    font-size: 16px;
                    line-height: 22px;
                    font-weight: 500;
                }
                .amp-relacionada .amp-imgWrapper {
                    position: relative;
                    aspect-ratio: 4 / 3;
                    flex-basis: calc(50% - 8px);
                    flex-shrink: 0;
                    flex-grow: 0;
                    border-radius: 16px;
                    overflow: hidden;
                }
                .amp-relacionada amp-img {
                    width: 100%;
                }
                p {
                    margin: 0 0 0.9rem 0;
                }
                amp-twitter {
                    height: 797px;
                }
                amp-img img {
                    object-fit: contain;
                    width: 100%;
                }
                .fixed-container {
                    width: 100%;
                    aspect-ratio: 16 / 9;
                    position: relative;
                    background-color: #21292c;
                    overflow: hidden;
                    border-radius: 16px;
                }
                figure.imatge {
                    margin-bottom: 15px;
                }
                figure {
                    margin: 0;
                }
                .noticiaRelacionada {
                    position: relative;
                    background-color: #f0f3f4;
                    border-radius: 16px;
                    padding: 16px;
                    margin-bottom: 48px;
                    margin-top: 48px;
                }
                .noticiaRelacionada a {
                    text-decoration: none;
                }
                .noticiaRelacionada h3 {
                    font-weight: 700;
                    text-decoration: none;
                    color: #111617;
                    font-size: 1.25rem;
                    padding-bottom: 16px;
                }
                .noticiaRelacionada .imatgeWrapper {
                    aspect-ratio: 16 / 9;
                    position: relative;
                    border-radius: 8px;
                    overflow: hidden;
                    margin-bottom: 24px;
                }
            `}</style>
            <article>
                {getMediaDestacat()}
                <div className='amp-itemNoticia'>
                    <div>
                        {avantitol && <p className=''>{avantitol}</p>}
                        {titol && <h1 className='amp-titol'>{titol}</h1>}
                        {entradeta && <div className='amp-entradeta'>{entradeta}</div>}
                    </div>
                    <div className='amp-info'>
                        {autors && <div className='amp-autor'>{getSignature()}</div>}
                        <div className='amp-data'>{getDataPublicacio()}</div>
                    </div>
                    <div className='amp-cos' dangerouslySetInnerHTML={{ __html: getParseCos(cos) }}></div>
                </div>
            </article>
            {noticies && <section className='amp-itemNoticia'>{getDataNoticies(noticies)}</section>}
        </>
    );
}
